import { idb } from './indexed';
import { encryptString, decryptString, type EncryptedBlob } from './crypto';

const SESSION_KEY = '_vg_sess';

function getSessionPassphrase(): string | null {
  return sessionStorage.getItem(SESSION_KEY);
}

export function setSessionPassphrase(passphrase: string) {
  sessionStorage.setItem(SESSION_KEY, passphrase);
}

export function clearSessionPassphrase() {
  sessionStorage.removeItem(SESSION_KEY);
}

export async function storeApiKey(
  provider: 'aivis' | 'claude' | 'kie',
  apiKey: string,
): Promise<void> {
  const passphrase = getSessionPassphrase();
  if (!passphrase) throw new Error('No session passphrase — call setSessionPassphrase first');
  const encrypted = await encryptString(apiKey, passphrase);
  await idb.put('apiKeys', encrypted, provider);
}

export async function loadApiKey(
  provider: 'aivis' | 'claude' | 'kie',
): Promise<string | null> {
  const passphrase = getSessionPassphrase();
  if (!passphrase) return null;
  const blob = (await idb.get<EncryptedBlob>('apiKeys', provider)) as
    | EncryptedBlob
    | undefined;
  if (!blob) return null;
  try {
    return await decryptString(blob, passphrase);
  } catch {
    return null;
  }
}

export async function deleteApiKey(
  provider: 'aivis' | 'claude' | 'kie',
): Promise<void> {
  await idb.delete('apiKeys', provider);
}
